import { Component, InputSignal, Signal, computed, input } from '@angular/core';

@Component({
  selector: 'app-icf-bar',
  standalone: true,
  imports: [],
  templateUrl: './icf-bar.component.html',
  styleUrl: './icf-bar.component.scss',
})
export class IcfBarComponent {
  // value: InputSignal<number> = input(0);
  valuePercent: InputSignal<number> = input(0);
  valueIcf: Signal<number> = computed(() => {
    const value = this.valuePercent();
    for (const level of this.damageLevels) {
      if (value >= level.min && value <= level.max) {
        return level.icf;
      }
    }
    return 4;
  });
  valuePercentEven: Signal<number> = computed(() => {
    const percent = this.valueIcf() * 25;
    return percent > 100 ? 100 : percent;
  });

  /*
  
ICF 0: #FFFFFF

ICF 1: #F4F7D0

ICF 2: #E8E596

ICF 3: #EEB27B

ICF 4: #F4856D
  */

  damageLevels = [
    { icf: 4, min: 96, max: 100, color: '#F4856D' }, // Schädigung voll ausgeprägt
    { icf: 3, min: 50, max: 95, color: '#EEB27B' }, // Schädigung erheblich ausgeprägt
    { icf: 2, min: 25, max: 49, color: '#E8E596' }, // Schädigung mäßig ausgeprägt
    { icf: 1, min: 5, max: 24, color: '#F4F7D0' }, // Schädigung leicht ausgeprägt
    { icf: 0, min: 0, max: 4, color: 'lightgray' }, // Schädigung nicht vorhanden
  ];

  /*

  0: Schädigung nicht vorhanden (0 - 4 %)

1: Schädigung leicht ausgeprägt (5 - 24 %)

2: Schädigung mäßig ausgeprägt (25 - 49 %)

3: Schädigung erheblich ausgeprägt (50 - 95 %)

4: Schädigung voll ausgeprägt (96 - 100 %)

    { min: 96, max: 100, color: 'rgba(251,221,221,1)' }, // Schädigung voll ausgeprägt
    { min: 50, max: 95, color: 'rgba(255,228,200,1)' }, // Schädigung erheblich ausgeprägt
    { min: 25, max: 49, color: 'rgba(252,244,219,1)' }, // Schädigung mäßig ausgeprägt
    { min: 5, max: 24, color: 'rgba(252,252,239,1)' }, // Schädigung leicht ausgeprägt
    { min: 0, max: 4, color: 'white' }, // Schädigung nicht vorhanden


  drawChartBackground(gradientBack: any) {
    gradientBack.addColorStop(0, 'rgba(255,255,255,1)');
    gradientBack.addColorStop(0.2, 'rgba(255,255,255,1)');

    gradientBack.addColorStop(0.2, 'rgba(252,252,239,1)');
    gradientBack.addColorStop(0.4, 'rgba(252,252,239,1)');

    gradientBack.addColorStop(0.4, 'rgba(252,244,219,1)');
    gradientBack.addColorStop(0.6, 'rgba(252,244,219,1)');

    gradientBack.addColorStop(0.6, 'rgba(255,228,200,1)');
    gradientBack.addColorStop(0.8, 'rgba(255,228,200,1)');

    gradientBack.addColorStop(0.8, 'rgba(251,221,221,1)');
    gradientBack.addColorStop(1, 'rgba(251,221,221,1)');
  */

  getBorderColor(): string {
    for (const level of this.damageLevels) {
      if (this.valuePercent() >= level.min && this.valuePercent() <= level.max) {
        return level.color;
      }
    }
    return 'lightgray'; // Standardfarbe, falls keine Bedingung zutrifft
  }
  getBackgroundColor(): string {
    for (const level of this.damageLevels) {
      if (this.valuePercent() >= level.min && this.valuePercent() <= level.max) {
        return level.color;
      }
    }
    return 'white'; // Standardfarbe, falls keine Bedingung zutrifft
  }

  // getColor(): string {
  //   for (const level of this.damageLevels) {
  //     if (this.value() === level.icf) {
  //       return level.color;
  //     }
  //   }
  //   return 'white'; // Standardfarbe, falls keine Bedingung zutrifft
  // }
}
